// Connections the editor refuses while the user draws. Each key has a Hebrew text, so the user never sees engine wording.

export type ConnectionRefusal = 'second-parent' | 'mixed-children' | 'into-root'

export const CONNECTION_REFUSAL_TEXT: Record<ConnectionRefusal, string> = {
  'second-parent': 'לכל צומת יכול להיות רק חיבור אחד מלמעלה',
  'mixed-children': 'אי אפשר לחבר תנאים ופעולה לאותו צומת',
  'into-root': 'אי אפשר לחבר רכיב מעל הרכיב הראשון בעץ. חברו את הרכיב מתחתיו',
}

type FlowNode = { id: string; type?: string }
type FlowEdge = { source: string; target: string }
type Connection = { source?: string | null; target?: string | null }

const ACTION_UI = new Set(['message', 'crm'])
const CONDITION_UI = new Set([
  'connection',
  'time',
  'consumption',
  'meter',
  'network',
])

export function connectionRefusal(
  nodes: FlowNode[],
  edges: FlowEdge[],
  connection: Connection,
  rootId: string
): ConnectionRefusal | null {
  // The tree is read from the root down, so nothing sits above the root.
  // A node joined above it would be cut off from the root.
  if (connection.target === rootId) return 'into-root'
  if (edges.some(e => e.target === connection.target)) return 'second-parent'

  const typeOf = (id?: string | null) => nodes.find(n => n.id === id)?.type
  const childTypes = edges
    .filter(e => e.source === connection.source)
    .map(e => typeOf(e.target))
  const hasActionChild = childTypes.some(t => t && ACTION_UI.has(t))
  const hasConditionChild = childTypes.some(t => t && CONDITION_UI.has(t))
  const targetType = typeOf(connection.target)
  const targetIsAction = !!targetType && ACTION_UI.has(targetType)
  const targetIsCondition = !!targetType && CONDITION_UI.has(targetType)
  if (
    (targetIsAction && hasConditionChild) ||
    (targetIsCondition && hasActionChild)
  ) {
    return 'mixed-children'
  }
  return null
}
